import { createFormContext } from '@mantine/form';

import { OrderForm, OrderFormTransformedType } from 'store/pricing/types';

export const [OrderFormProvider, useOrderFormContext, useOrderForm] = createFormContext<
  OrderForm,
  (values: OrderForm) => OrderFormTransformedType
>();
